import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HsePopperArrow from './HsePopperArrow.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HsePopperArrow;

/* template */
var __vue_render__ = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g(_vm._b({staticClass:"hse-PopperArrow",attrs:{"data-popper-arrow":""}},'div',_vm.data.attrs,false),_vm.listeners),[_c('svg',{attrs:{"fill":"none","height":"6","viewBox":"0 0 15 6","width":"15","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":_vm.props.color,"d":"M6.03088 5.45304C6.82047 6.18024 8.16955 6.1823 8.96232 5.45924C8.96683 5.45513 8.96893 5.45319 8.97346 5.44909C9.11558 5.32058 12.6919 2.08695 15 -7.3021e-06C9.14214 -5.65845e-06 0 -3.09325e-06 0 -3.09325e-06L6.03088 5.45304Z"}})])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = true;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
